"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveMemberRequest = void 0;
var ActiveMemberRequest = /** @class */ (function () {
    function ActiveMemberRequest() {
    }
    return ActiveMemberRequest;
}());
exports.ActiveMemberRequest = ActiveMemberRequest;
;
//# sourceMappingURL=activeMember.request.js.map